import { render, staticRenderFns } from "./RegistrationConfirmed.vue?vue&type=template&id=e5c270e6&scoped=true"
import script from "./RegistrationConfirmed.vue?vue&type=script&lang=js"
export * from "./RegistrationConfirmed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5c270e6",
  null
  
)

export default component.exports